import { components } from '@/common/bag-api';
import { CamelCaseKeys } from '@/common/types/snake-to-camel-case';

export enum OrganizationBankAccountMode {
	ADD = 'add',
	EDIT = 'edit',
}

export type OrganizationBankAccountDialogData = {
	mode: OrganizationBankAccountMode;
	bankAccount: BankAccountUpdatePayload;
};

export type BankAccount = CamelCaseKeys<components['schemas']['BankAccount']>;

export type BankAccountUpdatePayload = Omit<BankAccount, 'currency'> & {
	currency: number | CamelCaseKeys<components['schemas']['Currency']>;
};

export interface BulkUpdateBankAccountPayload {
	note?: string;
	kind: number;
	currency: number;
	isActive?: boolean;
	number: string;
	swift?: string;
	organization?: number;
	mainAccount?: boolean;
	fastAlior?: boolean;
}
